import { css } from "@emotion/react";
import styled from "../../../../config/emotion";
import { StyledCompProps } from "../../../../globalTypes/theme";

export const MobileRowsWrapper = styled.div`
  width: 100%;
  padding: 0 !important;

  flex: 1 0;
  max-width: 100%;
`;

export const MobileCellsContainer = styled.form<
  StyledCompProps & { isSelected: boolean }
>`
  display: block;
  margin: 2px auto;
  border: 1px solid #eaeaea;
  padding: 8px;
  min-width: 260px;
  padding-left: 20px;
  padding-right: 20px;
  overflow: hidden;
  position: relative;
  background-color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.primaryColor.concat("3b") : "white"} !important;
`;

export const MobileRowsContainer = styled.div`
  position: relative;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
`;

export const tableRowLoaderCss = css`
  height: auto;
`;

export const MobileRowsFlexWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -1rem;
`;

export const MobileRowsPaddingDiv = styled.div`
  padding: 0 1rem;
  width: 100%;
  position: relative;
`;

export const TableRowStoryContainer = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TableRowStoryWrapper = styled.div`
  position: relative;

  font-family: arial;
  background-color: cyan;
  border: 2px solid darkblue;
`;

export const SelectedRowsCounter = styled.span<{ visible: boolean }>`
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;

  width: 3.5rem;
  height: 3.5rem;

  border-radius: 50%;
  display: grid;
  place-items: center;

  color: #fff;
  background-color: ${({ theme }) => theme.colors.secondaryColor};

  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);

  font-size: 1.4rem;

  transition: 0.3s ease-in-out;
  translate: ${({ visible }) => (visible ? "0" : "5.5rem")} 0;

  z-index: 1000;
`;
